let Drop = mc.widgets.Drop;
let StudyFormView = require("../view/StudyFormView");
let LifecycleStateFlag = require("./LifecycleStateFlag");

class StudyDrop extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      term: ""
    };
  }

  selectStudy(studyId) {
    let id = mc.router.id();

    if (["DESIGN_STUDY_VIEW", "SUBJECT_LIST_VIEW"].includes(id)) {
      mc.router.refresh({ studyId });
    }
    else {
      mc.router.trigger("DESIGN_STUDY_VIEW", { studyId });
    }
  }

  createStudy() {
    StudyFormView.open(null);
  }

  shouldComponentUpdate(nextProps) {
    let { studyId } = nextProps;

    return !studyId || !!nextProps.studies.find((study) => study.id === studyId);
  }

  setTerm(evt) {
    this.setState({
      term: evt.target.value
    });
  }

  render() {
    let { studies, studyId } = this.props;
    let { term } = this.state;

    let study = studies.find((study) => study.id === studyId);

    if (!study) {
      return null;
    }

    let tease = function (str, n) {
      let a = str.split(/\s+/);
      return a.slice(0, n).join(" ") + (a.length > n ? "..." : "");
    };

    let results = mc.utils.filter(studies, ["displayName", "title"], term);

    let items = results.map(function (study) {
      return (
        <li key={study.id} data-study-id={study.id}>
          <button onClick={this.selectStudy.bind(this, study.id)}>
            <div className="rc-study-drop-study-name">
              {study.displayName}
            </div>
            <div className="rc-study-drop-study-title">
              <LifecycleStateFlag lifecycleState={study.lifecycleState}/>
              {tease(study.title, 10)}
            </div>
          </button>
        </li>
      );
    }, this);

    return (
      <div className="rc-study-drop">
        <Drop autoClose={true}>
          <div className="rc-study-drop-handle mc-drop-handle">
            <span>{study.displayName}</span>
          </div>
          <div className="rc-study-drop-content mc-drop-content" onMouseOver={mc.ui.freeze.bind(null, true)} onMouseOut={mc.ui.freeze.bind(null, false)}>
            <button className="rc-study-drop-plus" onClick={this.createStudy.bind(this)}>
              {tx("new_study")}
            </button>
            <div className="rc-study-drop-form">
              <input type="search" value={term} onChange={this.setTerm.bind(this)} placeholder={tx("search")}/>
            </div>
            <ul>
              {items}
            </ul>
          </div>
        </Drop>
      </div>
    );
  }
}

module.exports = StudyDrop;
